window.CartDrawerController = (function() {
  let cartDrawer = null;

  function init() {
    if (!cartDrawer) cartDrawer = document.querySelector('cart-drawer');
    return !!cartDrawer;
  }

  function updateElementFromHTML(htmlString, selector, targetEl) {
    const source = new DOMParser().parseFromString(htmlString, 'text/html').querySelector(selector);
    if (source) targetEl.innerHTML = source.innerHTML;
  }

  function openCartDrawer() {
    if (!init()) return false;
    cartDrawer.open();
    return true;
  }

  function closeCartDrawer() {
    if (!init()) return false;
    cartDrawer.close();
    return true;
  }

  function cartRoot() {
    return window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  }

  function updateCartContents(providedSections) {
    if (!init()) return Promise.reject('Cart drawer not initialized');

    const complete = providedSections && ['cart-drawer', 'cart-icon-bubble'].every(
      key => typeof providedSections[key] === 'string' && providedSections[key].trim()
    );
    return (complete ? Promise.resolve(providedSections) :
      fetch(cartRoot() + 'cart?sections=cart-drawer,cart-icon-bubble')
        .then(response => {
          if (!response.ok) throw new Error('Could not refresh cart');
          return response.json();
        }))
      .then(sections => {
        if (!sections || !['cart-drawer', 'cart-icon-bubble'].every(key => typeof sections[key] === 'string' && sections[key].trim())) {
          throw new Error('Invalid response format from cart sections');
        }

        if (sections['cart-drawer']) {
          cartDrawer.classList.toggle('is-empty', sections['cart-drawer'].includes('is-empty'));
        }

        try {
          cartDrawer.renderContents({ sections });
        } catch (e) {
          if (sections['cart-drawer']) {
            const drawerInner = cartDrawer.querySelector('.drawer__inner');
            if (drawerInner) updateElementFromHTML(sections['cart-drawer'], '.drawer__inner', drawerInner);
          }
          if (sections['cart-icon-bubble']) {
            const iconBubble = document.getElementById('cart-icon-bubble');
            if (iconBubble) updateElementFromHTML(sections['cart-icon-bubble'], '#cart-icon-bubble', iconBubble);
          }
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'cart-drawer-controller', renderedSections: ['cart-drawer', 'cart-icon-bubble']
          });
        }
        return sections;
      })
      .catch(error => {
        console.error('Error updating cart drawer:', error);
        throw error;
      });
  }

  function addItemAndOpenDrawer(variantId, quantity, properties) {
    quantity = Math.max(1, parseInt(quantity) || 1);
    properties = properties || {};
    if (!init()) return Promise.reject('Cart drawer not initialized');
    if (!variantId || isNaN(Number(variantId))) return Promise.reject('Invalid variant ID');

    const data = { items: [{ id: variantId, quantity }],
      sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname };
    if (Object.keys(properties).length > 0) data.items[0].properties = properties;

    return fetch(cartRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    .then(response => {
      if (!response.ok) return response.json().catch(() => ({})).then(d => { throw new Error(d.description || response.statusText || 'Error adding item'); });
      return response.json();
    })
    .then(result => updateCartContents(result.sections)
      .then(() => { openCartDrawer(); return true; })
      .catch(error => {
        // The item is already added. Do not invite a second add when rendering fails.
        console.error('Cart added, but drawer could not refresh:', error);
        window.location.href = cartRoot() + 'cart';
        return true;
      }))
    .catch(error => { console.error('Error adding item to cart:', error); throw error; });
  }

  return {
    open: openCartDrawer,
    close: closeCartDrawer,
    update: updateCartContents,
    addItem: addItemAndOpenDrawer
  };
})();
